// extracted by mini-css-extract-plugin
export default {"wrap":"oz-z","melodyCategory":"pz-z","fullWidth":"qz-z","items":"rz-z","featureCss":"sz-z","disabled":"tz-z","imgCss":"uz-z"};